import * as _ from "../../../util/lodash";
import React from 'react';
import { compose } from 'react-recompose';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles, mapHandlers } from "../../core/hoc";
import { tooltipify } from "../../core/tooltip";
import Input from "../../core/input";
import Button from "../../core/button";
import Icon from "../../core/icon";
import { positions } from "../../../enums";
var BigSearch = createComponent({
  displayName: 'BigSearchCmp',
  propTypes: {
    initialValue: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    actionText: PropTypes.string,
    isDisabledAction: PropTypes.bool
  },
  defaultProps: {
    initialValue: '',
    onChange: _.noop,
    onSubmit: undefined,
    placeholder: undefined,
    actionText: undefined,
    isDisabledAction: false
  },
  state: {
    searchValue: {
      value: function value(p) {
        return p.initialValue;
      },
      updater: 'setSearchValue'
    }
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      // new prop initialValue should override local scope searchValue
      if (this.props.initialValue !== nextProps.initialValue && nextProps.searchValue !== nextProps.initialValue) {
        this.props.setSearchValue(nextProps.initialValue);
      }
    }
  },
  handlers: {
    handleClear: function handleClear(p) {
      return function (e) {
        p.setSearchValue('');
        p.onChange(e, {
          value: ''
        });
        !!p.onSubmit && p.onSubmit(e, {
          value: ''
        });
      };
    },
    handleInputChange: function handleInputChange(p) {
      return function (e, _ref) {
        var value = _ref.value;
        p.setSearchValue(value);
        p.onChange(e, {
          value: value
        });
      };
    },
    handleSubmit: function handleSubmit(p) {
      return function (e) {
        e.preventDefault();
        !!p.onSubmit && p.onSubmit(e, {
          value: p.searchValue
        });
      };
    }
  },
  render: function render(p) {
    var _cx = cx({
      'big-search': true
    });

    var isPopulated = p.searchValue || p.initialValue;
    var input = /*#__PURE__*/React.createElement(Input, {
      isDisabledAction: p.isDisabledAction,
      isFluid: true,
      icon: {
        content: 'search',
        position: positions.LEFT
      },
      innerLabel: isPopulated ? {
        content: /*#__PURE__*/React.createElement(Icon, {
          name: "cancel",
          onClick: p.handleClear
        }),
        position: positions.RIGHT
      } : undefined,
      placeholder: p.placeholder,
      onChange: p.handleInputChange //[Victor]: this will allow us to change the value to empty on the search query text in CS moderation search
      ,
      value: p.searchValue === '' || p.searchValue ? p.searchValue : p.initialValue,
      action: isPopulated && !!p.actionText ? /*#__PURE__*/React.createElement(Button.Primary, {
        text: p.actionText,
        onClick: p.handleSubmit
      }) : null
    });
    return /*#__PURE__*/React.createElement("div", {
      className: _cx
    }, !!p.onSubmit ? /*#__PURE__*/React.createElement("form", {
      onSubmit: p.handleSubmit
    }, input) : input);
  }
});
export var PrivateBigSearch = compose(tooltipify({
  isInline: false
}), mapHandlers({
  click: []
}), whitelistStyles())(BigSearch);
export default PrivateBigSearch;
//# sourceMappingURL=index.js.map